"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.HeaderTransformer = exports.RowTransformerValidator = void 0;
var RowTransformerValidator_1 = require("./RowTransformerValidator");
Object.defineProperty(exports, "RowTransformerValidator", {
  enumerable: true,
  get: function () {
    return RowTransformerValidator_1.RowTransformerValidator;
  }
});
var HeaderTransformer_1 = require("./HeaderTransformer");
Object.defineProperty(exports, "HeaderTransformer", {
  enumerable: true,
  get: function () {
    return HeaderTransformer_1.HeaderTransformer;
  }
});
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJuYW1lcyI6WyJSb3dUcmFuc2Zvcm1lclZhbGlkYXRvcl8xIiwicmVxdWlyZSIsIk9iamVjdCIsImRlZmluZVByb3BlcnR5IiwiZXhwb3J0cyIsImVudW1lcmFibGUiLCJnZXQiLCJSb3dUcmFuc2Zvcm1lclZhbGlkYXRvciIsIkhlYWRlclRyYW5zZm9ybWVyXzEiLCJIZWFkZXJUcmFuc2Zvcm1lciJdLCJzb3VyY2VzIjpbIi4uLy4uLy4uL3NyYy90cmFuc2Zvcm1zL2luZGV4LnRzIl0sInNvdXJjZXNDb250ZW50IjpbbnVsbF0sIm1hcHBpbmdzIjoiOzs7Ozs7QUFBQSxJQUFBQSx5QkFBQSxHQUFBQyxPQUFBO0FBQVNDLE1BQUEsQ0FBQUMsY0FBQSxDQUFBQyxPQUFBO0VBQUFDLFVBQUE7RUFBQUMsR0FBQSxXQUFBQSxDQUFBO0lBQUEsT0FBQU4seUJBQUEsQ0FBQU8sdUJBQXVCO0VBQUE7QUFBQTtBQUNoQyxJQUFBQyxtQkFBQSxHQUFBUCxPQUFBO0FBQVNDLE1BQUEsQ0FBQUMsY0FBQSxDQUFBQyxPQUFBO0VBQUFDLFVBQUE7RUFBQUMsR0FBQSxXQUFBQSxDQUFBO0lBQUEsT0FBQUUsbUJBQUEsQ0FBQUMsaUJBQWlCO0VBQUE7QUFBQSIsImlnbm9yZUxpc3QiOltdfQ==